var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2171.769 -6401.521 27.534 44.236",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-27 {\n        opacity: 0.645;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_582861_cc",
    transform: "translate(-2171.769 -6401.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M38.916,5.407A13.752,13.752,0,0,0,33.8,5.161C25.248,6.735,19.643,15.437,22.987,23.3c3.786,8.85,8.555,17.307,12.783,25.96C40,40.61,44.767,32.2,48.553,23.353,51.749,15.831,46.832,7.62,38.916,5.407ZM35.77,26.745a7.547,7.547,0,1,1,7.473-7.522A7.523,7.523,0,0,1,35.77,26.745Z",
    transform: "translate(-22.006 -5.027)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.5cbeedd5.svg";
export { ForwardRef as ReactComponent };